/* eslint-disable indent */
import ShieldService from '@/services/ShieldService';
import StoryPhoneService from '@/services/StoryphoneService';

import * as types from './mutation-types';

const shieldService = new ShieldService();
const deviceService = new StoryPhoneService();

export const fetchShieldsByDeviceId = ({ commit }, deviceId) => new Promise(
    (resolve, reject) => {
        shieldService
            .getShieldsByDeviceId(deviceId)
            .then((response) => {
                const shields = response?.data?.items || [];
                commit(types.SHIELDS_BY_DEVICE_ID, { deviceId, shields });
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    },
);

export const fetchDevicesByShieldId = ({ commit }, shieldId) => new Promise(
    (resolve, reject) => {
        shieldService
            .getDevicesByShieldId(shieldId)
            .then((response) => {
                const devices = response?.data?.items || [];
                commit(types.DEVICES_BY_SHIELD_ID, { shieldId, devices });
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    },
);

export const fetchDevicesByUserId = ({ commit }, userId) => new Promise(
    (resolve, reject) => {
        deviceService
            .getDevicesByUserId(userId)
            .then((response) => {
                const devices = response?.data?.items || [];
                commit(types.DEVICES_BY_USER_ID, devices);
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    },
);

export const fetchShieldsByUserId = ({ commit }, userId) => new Promise(
    (resolve, reject) => {
        shieldService
            .getShieldsByUserId(userId)
            .then((response) => {
                const shields = response?.data?.items || [];
                commit(types.SHIELDS_BY_USER_ID, shields);
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    },
);
